import { Button, Input, Flex } from 'antd';
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import common_axios from "./../commonAxios";
import "./LoginPage.css";


const LoginPage = () => {
    const [userName, setUserName] = useState("");
    const [loginCode, setLoginCode] = useState("");

    const navigate = useNavigate();

    const attemptLogin = () => {
        common_axios.post(`${process.env.REACT_APP_API_URL}/login/attemptLogin`, {
            userName: userName,
            loginCode: loginCode
        })
            .then((response) => {
                console.log(response);
                localStorage.setItem('accessToken', response.data.jwt);
                localStorage.setItem('username', response.data.username);
                localStorage.setItem('userid', response.data.id);
                localStorage.setItem('roleStrength', response.data.strength);
                setTimeout(() => { navigate("/stats"); window.location.reload(false); }, 1000);
            })
            .catch(error => {
                console.error(error);
            });
    }

    return (
        <Flex className='wrapper'>
            <label>(HIER KOMMT DAS LOGO HIN)</label>
            <Flex vertical className='form'>
                <label className='title'>LOGIN</label>
                <Input className='inputField' placeholder="Username" onChange={(value) => { setUserName(value.target.value); }} />
                <Input className='inputField' placeholder="LoginCode" onChange={(value) => { setLoginCode(value.target.value); }} />
                <Button className='buttonSubmit' onClick={attemptLogin}>Log in</Button>
            </Flex>
        </Flex >
    );
};

export default LoginPage;